import SpecialtyMixin from '@/shared/mixins/specialty.mixin'
import AuthMixin from '@/shared/mixins/auth.mixin'
import ReviewExamsMixin from '@/shared/mixins/review-report.mixin'
import DateMixin from '@/shared/mixins/date.mixin'
import ReviewHeader from '@/components/medico/reviewHeader/index.vue'
import ModalRevisarLaudo from '@/components/modalRevisarLaudo/index.vue'
import RadioReportPopUp from '@/components/radio-popup/index.vue'
import { sanitizeReportText } from '@/shared/utils/sanitize-report-text'

export default {
  name: 'ReviewReport',
  mixins: [SpecialtyMixin, AuthMixin, ReviewExamsMixin, DateMixin],
  components: {
    ReviewHeader,
    ModalRevisarLaudo,
    RadioReportPopUp
  },
  data() {
    return {
      reRenderKey: 0,
      reportText: '',
      examSelected: null,
      items: [],
      filteredItems: [],
      query: '',
      paginatedItems: [],
      viewingObservation: false,
      currentReport: null,
      currentObservation: {},
      isLoading: false,
      interval: null,
      selectedMasks: [],
      isReadOnly: false,
      repeat: false,
      reportStatus: '',
      abnormal: null,
      masks: [],
      showMasks: false,
      isAbnormal: false,
      reportCorrectionNotice: false,
      specialties: [],
      selectedSpecialty: null,
      showSpecialtyDropdown: false,
      description: '',
      pinnedExam: null,
      showDialog: 0,
      openDialog: false,
      nextExamId: null,
      isMounted: false,
      hasLoaded: false,
      lastUpdated: new Date(),
      isTimerActive: false,
      examDetails: '',
      hasUrgencyAlert: false,
      lastReportText: '',
      notifications: [],
      showEditButton: true,
      isCollapsed: true,
      isTextareaDisabled: false,
      showMaintainButton: false,
      showSubmitButton: true,
      isMaintainClicked: false,
      isEditClicked: false,
      icon: '',
      reportDescriptionDetails: '',
      currentPage: 1,
      pageSize: 10,
      pageSizes: [10, 20, 50],
      totalItems: 0,
      totalPages: 1,
      isRetifying: false,
      titleReport: '',
      showRetifyPopup: false,
      retifyPopupExamId: null,
      isPreviousAccordionOpen: false,
      previousExamSearchId: '',
      previousExams: [],
      previousExamSearched: false,
      showCpfSearch: false,
      cpfSearch: '',
      advancedSearch: {
        name: '',
        dateOfBirth: '',
        gender: ''
      },
      advancedSearchErrors: {
        name: false
      }
    }
  },
  async mounted() {
    await this.load()
    await this.fetchMasks()
    this.isMounted = true
  },
  watch: {
    items: 'filterItems',
    reportText: {
      handler(newText, oldText) {
        if (newText !== oldText) {
          this.checkAndDeselectMasks()
        }
      }
    },
    isAbnormal: {
      handler(newValue) {
        this.fetchMasks()
        this.autoSelectSpecialtyIfOnlyOne()
      }
    },
    examDetails(newVal) {
      if (newVal && newVal.retification) {
        this.showEditButton = true
        this.showMaintainButton = true
        this.showSubmitButton = false
      } else {
        this.showEditButton = false
        this.showMaintainButton = false
        this.showSubmitButton = true
      }
    },
    repeat(newValue) {
      if (newValue) {
        this.reportStatus = ''
      }
    }
  },
  computed: {
    sortedItems: {
      get() {
        return this.filteredItems
      },
      set(value) {
        this.filteredItems = value
      },
      totalPages() {
        return Math.ceil(this.totalItems / this.pageSize)
      }
    },

    shouldShowSpecialtyDropdown() {
      return (
        (!this.filteredSpecialties || this.filteredSpecialties.length !== 1) &&
        !this.repeat &&
        this.reportStatus !== 'alterado' &&
        this.reportStatus !== 'normal' &&
        this.reportStatus
      )
    },
    filteredSpecialties() {
      if (!this.masks.length) return []

      const specialtiesWithMatchingMasks = this.masks
        .filter((mask) => {
          if (this.isAbnormal) {
            return Boolean(mask.isChanged) === true
          } else {
            return Boolean(mask.isChanged) === false
          }
        })
        .map((mask) => mask.specialityId)
      return [...new Set(specialtiesWithMatchingMasks)]
    },
    filteredMasks() {
      if (!this.selectedSpecialty) return []
      return this.masks.filter((mask) => {
        const hasMatchingSpecialty = mask.specialityId === this.selectedSpecialty
        const hasMatchingStatus = this.isAbnormal ? Boolean(mask.isChanged) === true : Boolean(mask.isChanged) === false

        return hasMatchingSpecialty && hasMatchingStatus
      })
    },
    currentExam() {
      return this.items.find((item) => item.examId === this.examSelected)
    },
    headerExam() {
      const exam = this.currentExam || {}
      const detailsBelongToExam =
        this.examDetails &&
        typeof this.examDetails === 'object' &&
        Number(this.examDetails.examId) === Number(exam.examId)
      const detailLabels = detailsBelongToExam ? this.examDetails.labels : null

      return {
        ...exam,
        labels: detailLabels && detailLabels.length ? detailLabels : exam.labels || []
      }
    },
    formattedLastUpdated() {
      return this.$moment(this.lastUpdated).format('DD/MM/YYYY HH:mm:ss')
    },
    formattedCreationDate() {
      return this.$moment(this.examDetails.creationDate).format('DD/MM/YYYY HH:mm')
    },
    messageRadioReport() {
      if (this.showDialog === 1) {
        return this.$i18n.t('radio_report.change_exam_warning')
      }
      if (this.showDialog === 2) {
        return this.$i18n.t('radio_report.refresh_exams_warning')
      }
      if (this.showDialog === 3) {
        return this.$i18n.t('radio_report.duplicate_exam_warning')
      }
      return ''
    },
    isTomographyOrResonance() {
      if (!this.currentExam || !this.currentExam?.specialtyName) return false
      const name = this.currentExam.specialtyName.toUpperCase().trim()
      return name === 'TOMOGRAFIA' || name === 'RESSONANCIA'
    }
  },
  methods: {
    showDuplicateExamButton() {
      return this.details?.speciality?.id === this.$constants.SPECIALITY.TOMOGRAFIA
    },
    isTomography(specialtyName) {
      return specialtyName?.toUpperCase().trim() === 'TOMOGRAFIA'
    },
    handleOpenReportPopup(examId) {
      this.examSelected = examId
      this.showDialog = 3
    },
    async handleDuplicateExam(examId) {
      this.examSelected = examId
      await this.duplicateExam(examId)

      this.$root.$emit('toast', {
        message: this.$i18n.t('radio_report.duplicate_exam_success'),
        type: 'success'
      })
      await this.handleRefresh()
    },
    getLimitedBodyParts(bodyParts = []) {
      if (!bodyParts || bodyParts.length <= 2) {
        return bodyParts || []
      }
      return bodyParts.slice(0, 2)
    },

    getExtraBodyPartsText(bodyParts = []) {
      if (!bodyParts || bodyParts.length <= 2) {
        return ''
      }
      const extraCount = bodyParts.length - 2
      return `+${extraCount}`
    },

    getAllBodyPartsTooltip(bodyParts = []) {
      if (!bodyParts || bodyParts.length <= 2) {
        return ''
      }
      const extraBodyParts = bodyParts.slice(2)
      return extraBodyParts.join(', ')
    },
    getSpecialtyName(specialtyId) {
      const specialty = this.items.find((item) => item.specialityId === specialtyId)
      if (specialty && specialty.specialtyName) {
        return specialty.specialtyName
      }

      if (this.examDetails && this.examDetails.specialityId === specialtyId && this.examDetails.specialtyName) {
        return this.examDetails.specialtyName
      }

      const specialtyMap = {
        19: 'ELETROCARDIOGRAMA',
        25: 'RX',
        53: 'RX-OIT',
        20: 'ELETROENCEFALOGRAMA',
        22: 'ESPIROMETRIA',
        87: 'TOMOGRAFIA',
        109: 'RESSONANCIA',
        110: 'MAMOGRAFIA',
        113: 'DENSITOMETRIA',
        16: 'ACUIDADE',
        24: 'MAPA',
        99: 'ESFORCO_CARDIOPULMONAR',
        75: 'TESTE_ERGOMETRICO',
        160: 'RM-PUNHO ESQUERDO'
      }

      return specialtyMap[specialtyId] || `Specialty ${specialtyId}`
    },

    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed
    },
    clearForm() {
      this.reportStatus = ''
      this.repeat = false
      this.reportText = ''
      this.clearReportFromStorage(this.examSelected)
      this.showEditButton = false
      this.showMasks = false
      this.isAbnormal = false
      this.selectedMasks = []
      this.selectedSpecialty = null
      this.showSpecialtyDropdown = false
    },
    enableTextarea() {
      if (this.examDetails.retification) {
        this.isTextareaDisabled = false
        this.showEditButton = false
        this.showMaintainButton = false
        this.showSubmitButton = true
        this.isEditClicked = true
        this.isMaintainClicked = false
      }
    },
    handleMaintain() {
      if (this.examDetails.retification) {
        this.isTextareaDisabled = true
        this.showMaintainButton = false
        this.showEditButton = false
        this.showSubmitButton = true
        this.isMaintainClicked = true
        this.isEditClicked = false
      }
    },
    async fetchMasks() {
      try {
        const specialityId = this.examDetails?.specialityId
        if (!specialityId) {
          return
        }

        const response = await this.getMaskOptions(specialityId)

        const allMasks = response.data.map((mask) => ({
          id: mask.id,
          title: mask.name, // Used in template display
          content: mask.text, // Used in tooltip
          isActive: mask.isActive,
          specialityId: mask.specialityId,
          languageId: mask.languageId,
          isChanged: mask.isChanged
        }))

        if (allMasks.length > 0) {
          this.autoSelectSpecialtyIfOnlyOne()
        }

        this.masks = allMasks

        const uniqueSpecialties = [...new Set(allMasks.map((mask) => mask.specialityId))]
        this.specialties = uniqueSpecialties

        if (this.examDetails.retification && this.examDetails.specialityId) {
          this.selectedSpecialty = this.examDetails.specialityId
        }
      } catch (error) {
        this.masks = []
      }
    },

    selectSpecialty(specialtyId) {
      this.selectedSpecialty = specialtyId
      this.showSpecialtyDropdown = false
    },

    toggleSpecialtyDropdown() {
      if (
        this.repeat ||
        this.reportStatus === 'alterado' ||
        (this.filteredSpecialties && this.filteredSpecialties.length === 1)
      ) {
        this.showSpecialtyDropdown = false
        return
      }
      this.showSpecialtyDropdown = !this.showSpecialtyDropdown
      if (this.showSpecialtyDropdown) {
        this.showMasks = true
      }
    },

    handleStatusChange(status) {
      this.reportStatus = status
      this.isAbnormal = status === 'alterado'
      if (status === 'alterado') {
        this.showSpecialtyDropdown = false
      }
      this.selectedSpecialty = null
      this.autoSelectSpecialtyIfOnlyOne()
    },
    handleMaskSelection(mask) {
      const maskIndex = this.selectedMasks.findIndex((m) => m.id === mask.id)

      if (maskIndex === -1) {
        this.selectedMasks.push(mask)
        this.reportText = this.reportText ? `${this.reportText}\n${mask.content}` : mask.content
      } else {
        this.selectedMasks.splice(maskIndex, 1)

        const contentToRemove = mask.content

        if (this.reportText === contentToRemove) {
          this.reportText = ''
        } else if (this.reportText.endsWith(`\n${contentToRemove}`)) {
          this.reportText = this.reportText.replace(`\n${contentToRemove}`, '')
        } else if (this.reportText.includes(`${contentToRemove}\n`)) {
          this.reportText = this.reportText.replace(`${contentToRemove}\n`, '')
        } else {
          this.reportText = this.reportText.replace(contentToRemove, '')
        }
      }
    },

    checkAndDeselectMasks() {
      if (!this.selectedMasks.length) return

      const selectedMasksCopy = [...this.selectedMasks]

      for (const mask of selectedMasksCopy) {
        const contentExists = this.isMaskContentInReport(mask.content)

        if (!contentExists) {
          const maskIndex = this.selectedMasks.findIndex((m) => m.id === mask.id)
          if (maskIndex !== -1) {
            this.selectedMasks.splice(maskIndex, 1)
          }
        }
      }
    },

    isMaskContentInReport(content) {
      if (!content || !this.reportText) return false

      if (this.reportText.includes(content)) return true

      const normalizedReportText = this.reportText.replace(/\s+/g, ' ').trim()
      const normalizedContent = content.replace(/\s+/g, ' ').trim()

      return normalizedReportText.includes(normalizedContent)
    },
    async handleForm() {
      try {
        // --- Caso de retificação ---
        if (this.isRetifying) {
          const payload = {
            reportText: sanitizeReportText(this.reportText),
            abnormal: this.reportStatus === 'alterado',
            titleReport: this.titleReport || null,
            reportCorrectionNotice: this.reportCorrectionNotice || null,
            edited: this.isRetifying
          }

          await this.sendReportFromReviewer(this.currentExam.examId, payload)
          this.$root.$emit('toast', {
            message: 'Retificação enviada com sucesso!',
            type: 'success'
          })

          this.isRetifying = false
          this.clearReportFromStorage(this.currentExam.examId)
          this.resetForm()
          await this.load()

          this.$nextTick(() => {
            if (this.sortedItems.length > 0) {
              this.selectExam(this.sortedItems[0].examId)
            }
          })

          return
        }

        // --- Caso de envio de laudo normal ---
        await this.handleMaintainReport()

        this.isRetifying = false
        this.clearReportFromStorage(this.currentExam.examId)
        this.resetForm()

        await this.load()
        this.$nextTick(() => {
          if (this.sortedItems.length > 0) {
            this.selectExam(this.sortedItems[0].examId)
          }
        })

        this.showFeedback()
      } catch (error) {
        this.$root.$emit('toast', {
          message: error.message || this.$i18n.t('radio_report.error_sending_report'),
          type: 'error'
        })
      }
    },

    async handleMaintainReport() {
      try {
        if (this.isLoading) return

        this.isLoading = true
        this.$root.$emit('showLoading')

        const payload = {
          reportText: this.reportText,
          examId: this.currentExam.examId,
          reasonId: 0,
          approved: true,
          abnormal: this.reportStatus === 'alterado',
          titleReport: this.titleReport,
          edited: this.isRetifying,
          reportCorrectionNotice: this.currentExam.reportCorrectionNotice || null
        }

        await this.sendMaintainReport(payload)
        this.$root.$emit('toast', {
          message: this.$i18n.t('radio_report.successfully_sent'),
          type: 'success'
        })
        this.clearReportFromStorage(this.currentExam.examId)
        this.resetForm()
        this.$nextTick(() => {
          if (this.sortedItems.length > 0) {
            this.selectExam(this.sortedItems[0].examId)
          }
        })
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
        this.$root.$emit('hideLoading')
        this.$emit('reloadReport')
        this.handleRefresh()
      }
    },

    toggleReportStatus(status) {
      if (this.reportStatus === status) {
        this.reportStatus = ''
        this.showMasks = false
        this.showSpecialtyDropdown = false
        this.selectedSpecialty = null
        this.selectedMasks = []
      } else {
        this.handleStatusChange(status)
      }
      if (this.repeat) {
        this.repeat = false
      }
    },
    autoSelectSpecialtyIfOnlyOne() {
      if (this.filteredSpecialties && this.filteredSpecialties.length === 1) {
        this.selectSpecialty(this.filteredSpecialties[0])
        this.showMasks = true
      }
    },
    async load() {
      this.isLoading = true
      this.hasLoaded = false
      try {
        const selectedExamId = this.examSelected || null
        const filters = {
          page: this.currentPage,
          pageSize: this.pageSize,
          patientName: '',
          examId: ''
        }
        if (this.query && /^\d+$/.test(this.query.trim())) {
          filters.examId = this.query.trim()
        } else if (this.query) {
          filters.patientName = this.query.trim()
        }
        const data = await this.getReviewExamsList(filters)
        let items = data.data
        this.totalItems = data.totalCount
        this.totalPages = Math.ceil(this.totalItems / this.pageSize) || 1

        if (this.currentPage > this.totalPages) {
          this.currentPage = this.totalPages
        }

        items = items.sort((a, b) => {
          if (a.emergency !== b.emergency) return b.emergency - a.emergency
          if (a.urgent !== b.urgent) return b.urgent - a.urgent
          if (!!a.comment !== !!b.comment) return b.comment - a.comment
          return a.patientName.localeCompare(b.patientName)
        })

        items = items.map((item) => {
          if (item.series && Array.isArray(item.series)) {
            item.bodyParts = item.series
          } else {
            item.bodyParts = []
          }

          return item
        })

        this.items = items
        this.filteredItems = [...this.items]
        this.lastUpdated = new Date()
        this.hasLoaded = true

        this.$nextTick(() => {
          this.reorderItems()
          if (this.filteredItems.length > 0) {
            const examToSelect = this.filteredItems.find((item) => item.examId === selectedExamId)
            if (examToSelect) {
              this.selectExam(examToSelect.examId)
            } else {
              this.selectExam(this.filteredItems[0].examId)
            }
            this.reRenderRadioHeader()
            this.stopTimer()
          } else {
            this.isTimerActive = true
            this.startTimer()
          }
        })
      } catch (error) {
        console.error('Erro ao carregar exames:', error)
      } finally {
        this.isLoading = false
      }
    },
    async changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page
        await this.load()
      }
    },
    async changePageSize() {
      this.currentPage = 1
      await this.load()
    },
    async fetchReportDescription(examId) {
      try {
        const response = await this.getReportDetails(examId)

        if (response) {
          this.reportDescriptionDetails = response
        } else {
          throw new Error('Resposta da API inválida')
        }
      } catch (error) {
        console.error('Erro ao buscar detalhes do relatório:', error)
      }
    },
    async handleRefresh() {
      try {
        const data = await this.getReviewExamsList()
        this.items = data.data
        this.lastUpdated = new Date()
        this.filterItems()
        this.reorderItems()

        // Atualizando series
        this.items.forEach((item) => {
          if (item.series && Array.isArray(item.series)) {
            item.bodyParts = item.series
          } else {
            item.bodyParts = []
          }
        })

        if (this.sortedItems.length > 0) {
          this.selectExam(this.sortedItems[0].examId)
        }

        this.$root.$emit('toast', {
          message: this.$i18n.t('radio_report.exams_list_updated'),
          type: 'success'
        })
      } catch (error) {}
    },
    startTimer() {
      if (this.interval) return
      this.interval = setInterval(async () => {
        await this.load()
      }, 30000)
    },
    stopTimer() {
      clearInterval(this.interval)
      this.interval = null
      this.isTimerActive = false
    },
    resetRadioMaskButtons() {
      this.abnormal = null
      if (this.$refs.radioMask) {
        this.$refs.radioMask.resetButtons()
      }
    },
    handleRefreshConfirmation() {
      this.load()
    },
    async refreshAfterSendInformation() {
      await this.load()

      if (this.sortedItems.length > 0) {
        this.selectExam(this.sortedItems[0].examId)
      }
    },
    filterItems() {
      this.filteredItems = this.items
        .filter(
          (item) =>
            item.patientName.toLowerCase().includes(this.query.toLowerCase()) ||
            item.examId.toString().includes(this.query) ||
            item.specialtyName.toLowerCase().includes(this.query.toLowerCase())
        )
        .map((item) => {
          item.truncatedPatientName = this.truncatePatientName(item.patientName)
          return item
        })

      this.reorderItems()

      if (!this.currentExam) {
        this.isTimerActive = true
        this.startTimer()
      }
    },
    handleRowSelected(examId) {
      if (this.examSelected === examId) return

      if (this.isRetifying) {
        this.retifyPopupExamId = examId
        this.showRetifyPopup = true
        return
      }
      this.reRenderKey++
      if (this.reportText.trim().length > 0) {
        this.showDialog = 1
        this.nextExamId = examId
      } else {
        this.selectExam(examId)
      }
      this.isEditClicked = false
    },
    confirmChangeRetifyExam () {
      this.showRetifyPopup = false
      this.isRetifying = false
      this.clearForm()
      this.selectExam(this.retifyPopupExamId)
      this.retifyPopupExamId = null
    },
    cancelChangeRetifyExam () {
      this.showRetifyPopup = false
      this.retifyPopupExamId = null
    },
    handleCloseComment() {
      this.viewingComment = false
    },
    handleCloseObservation() {
      this.viewingObservation = false
      this.$nextTick(() => {
        this.reorderItems()
      })
    },
    reorderItems() {
      this.filteredItems = [...this.filteredItems].sort((a, b) => {
        if (a.emergency !== b.emergency) return b.emergency - a.emergency
        if (a.urgent !== b.urgent) return b.urgent - a.urgent
        return new Date(a.openingDate) - new Date(b.openingDate)
      })
    },
    reRenderRadioHeader() {
      this.reRenderKey++
    },
    async selectExam(examId) {
      this.pinnedExam = examId
      this.examSelected = examId
      this.examDetails = ''
      this.resetRadioMaskButtons()
      this.resetForm()
      this.fetchReportDescription(examId)
      await this.fetchExamDetails(examId)

      const exam = this.items.find(item => item.examId === examId)
      this.reportCorrectionNotice = exam?.reportCorrectionNotice || null
      this.showEditButton = this.examDetails && this.examDetails.retification

      if (this.examDetails?.description) {
        this.reportText = this.examDetails.description
      }
    },
    async fetchExamDetails(examId) {
      try {
        const details = await this.getDetails(examId)

        if (!details || this.examSelected !== examId) {
          return
        }

        this.examDetails = {
          ...details,
          examId: details.examId || examId,
          specialityId: details.specialityId || details.specialtyId || (details.specialty && details.specialty.id)
        }

        if (details.labels && details.labels.length) {
          const exam = this.items.find((item) => item.examId === examId)
          if (exam) {
            this.$set(exam, 'labels', details.labels)
          }
        }
      } catch (error) {
        console.error('Erro ao buscar detalhes do exame:', error)
      }
    },
    resetForm() {
      this.reportStatus = ''
      this.repeat = false
      this.reportText = ''
      this.isAbnormal = false
      this.selectedMasks = []
      this.selectedSpecialty = null
      this.showSpecialtyDropdown = false
      this.resetRadioMaskButtons()
    },
    handleRepeatChange() {
      if (this.repeat) {
        this.reportStatus = ''
        this.showSpecialtyDropdown = false
        this.autoSelectSpecialtyIfOnlyOne()
      }
    },
    clearReportData() {
      this.description = ''
      if (this.$refs.report) {
        this.$refs.report.clear()
      }
    },
    clearReportFromStorage(examId) {
      const savedReports = JSON.parse(localStorage.getItem('savedReports')) || []
      const updatedReports = savedReports.filter((report) => report.id !== examId)
      localStorage.setItem('savedReports', JSON.stringify(updatedReports))
    },
    confirmChangeExam() {
      if (this.showDialog === 1) {
        this.clearForm()
        this.clearReportFromStorage(this.examSelected)
        this.selectExam(this.nextExamId)
        this.nextExamId = null
      } else if (this.showDialog === 3) {
        this.handleDuplicateExam(this.examSelected)
      } else {
        this.handleRefresh()
      }
      this.showDialog = 0
    },
    cancelChangeExam() {
      this.showDialog = 0
      this.nextExamId = null
    },
    async handleViewObservation(item) {
      this.examSelected = item.examId
      this.currentExam.notes = await this.getExamNotes(item.examId)
      this.viewingObservation = true
    },
    onChangeStatus(abnormal) {
      this.abnormal = abnormal
    },
    changeDescription(newDescription) {
      this.description = newDescription
    },
    showFeedback() {
      this.$root.$emit('toast', {
        message: this.$i18n.t('radio_report.successfully_sent'),
        type: 'success'
      })

      this.$nextTick(() => {
        if (this.sortedItems.length > 0) {
          this.selectExam(this.sortedItems[0].examId)
        }
      })

      this.examSelected = null
      this.description = ''
      this.abnormal = null
      this.isReadOnly = false

      if (this.$refs.report) {
        this.$refs.report.clear()
      }
    },
    truncatePatientName(name, maxLength = 23) {
      if (name.length <= maxLength) return name

      const nameParts = name.split(' ')
      let truncatedName = nameParts[0]

      for (let i = 1; i < nameParts.length; i++) {
        if ((truncatedName + ' ' + nameParts[i]).length > maxLength) {
          truncatedName += '...'
          break
        }
        truncatedName += ' ' + nameParts[i]
      }
      return truncatedName
    },

    handleOpenDialog() {
      this.openDialog = true
    },
    handleRetify() {
      // Ativa modo de retificação
      this.isRetifying = true
      this.isTextareaDisabled = false
      this.showEditButton = false
      this.showMaintainButton = false
      this.showSubmitButton = true
      this.isEditClicked = true
      this.isMaintainClicked = false

      // Pega a descrição atual do exame
      const fallbackDescription = this.reportDescriptionDetails || ''
      const description = this.examDetails?.description || fallbackDescription

      this.reportText = description
      this.titleReport = this.examDetails?.titleReport || ''
      this.reportStatus = this.examDetails?.isAlterado ? 'alterado' : 'normal'
    },

    handleCancelRetify() {
      this.isRetifying = false
      this.isTextareaDisabled = true
      this.isEditClicked = false
      this.reportText = this.examDetails?.description || ''
      this.titleReport = this.examDetails?.titleReport || ''
      this.reportStatus = this.examDetails?.isAlterado ? 'alterado' : 'normal'
    },
    handleRectify() {
      this.isTextareaDisabled = false

      this.reportStatus = this.examDetails.isAlterado ? 'alterado' : 'normal'

      this.isEditClicked = true

      this.showSubmitButton = true
      this.showEditButton = false
      this.showMaintainButton = false

      this.isRetifying = true

      this.reportText = this.examDetails.description || ''

      this.titleReport = this.examDetails.titleReport || ''
    },
    cancelRectify() {
      this.isRetifying = false
      this.isEditClicked = false
      this.reportText = this.examDetails.description || ''
      this.isTextareaDisabled = true
      this.showSubmitButton = false
    },
    async handleRemoteFilter() {
      this.clearExamSelection()
      this.currentPage = 1
      await this.load()
    },
    clearQuery() {
      this.query = ''
      this.handleRemoteFilter()
    },
    clearExamSelection() {
      this.examSelected = null
      this.reportDescriptionDetails = ''
      this.reportText = ''
    },
    getColorClass (confidence) {
      if (confidence == null || confidence === undefined) return 'color-gray'
      if (confidence >= 90) return 'color-green'
      if (confidence >= 70) return 'color-yellow'
      return 'color-red'
    },
    async togglePreviousAccordion () {
      this.isPreviousAccordionOpen = !this.isPreviousAccordionOpen
      if (this.isPreviousAccordionOpen && this.examSelected) {
        await this.loadPreviousExams(this.examSelected)
      }
      if (!this.isPreviousAccordionOpen) {
        this.previousExamSearched = false
      }
    },
    async fetchPreviousExams () {
      if (this.showAdvancedSearch) return
      const cpf = this.cpfSearch.trim()
      if (!/^\d{11}$/.test(cpf)) {
        this.previousExams = []
        this.previousExamSearched = true
        return
      }
      try {
        this.previousExams = await this.getFreeFilteredExams({ document: cpf }, this.examSelected)
      } catch (error) {
        this.previousExams = []
      } finally {
        this.previousExamSearched = true
      }
    },
    async handleAdvancedSearch () {
      const { name, dateOfBirth, gender } = this.advancedSearch
      const examId = this.examSelected
      try {
        this.previousExams = await this.getFreeFilteredExams(
          {
            name,
            dateOfBirth: dateOfBirth?.replace(/\//g, '-'),
            gender
          },
          examId
        )
      } catch (error) {
        this.previousExams = []
      } finally {
        this.previousExamSearched = true
      }
    },
    resetAdvancedSearch () {
      this.showCpfSearch = false
      this.cpfSearch = ''
      this.advancedSearch = {
        name: '',
        dateOfBirth: '',
        gender: ''
      }
      this.advancedSearchErrors = {
        name: false
      }
      this.previousExams = []
      this.previousExamSearched = false
    },
    toggleCpfSearch (value) {
      this.showCpfSearch = value
      this.previousExams = []
      this.previousExamSearched = false
      if (!value) {
        this.cpfSearch = ''
      }
    },
    validateAndSearchAdvanced () {
      this.advancedSearchErrors.name = false
      if (!this.advancedSearch.name.trim()) {
        this.advancedSearchErrors.name = true
        return
      }
      this.handleAdvancedSearch()
    },
    async loadPreviousExams (examId) {
      if (!examId) return

      try {
        const exams = await this.getPreviousExamsByExamId(examId)
        this.previousExams = exams || []
      } catch (error) {
        console.error('Erro ao buscar exames anteriores:', error)
        this.previousExams = []
      } finally {
        this.previousExamSearched = true
        await this.$nextTick()
      }
    },
    openDicomViewer (url) {
      window.open(url, '_blank')
    },
    openReport (examId) {
      const exam = this.previousExams.find((e) => e.examId === examId)
      const url = exam?.reportURL
      if (url) {
        window.open(url, '_blank')
      }
    },
    formatDate (date) {
      if (!date) return ''
      return this.$moment(date).format('DD/MM/YYYY HH:mm')
    },
    formatDateBirth (date) {
      if (!date) return ''
      return this.$moment(date).format('DD/MM/YYYY')
    },
    resetPreviousExamsAccordion () {
      this.isPreviousAccordionOpen = false
      this.previousExamSearchId = ''
      this.previousExams = []
      this.previousExamSearched = false
    }
  }
}
